(ns machtfit.stepchall.details
  (:require [machtfit.core :as machtfit]
            [machtfit.format :as format]
            [machtfit.language :as language]
            [machtfit.stepchall.subs :as subs]
            [machtfit.translation :refer [t str-tr format-date]]
            [re-frame.core :as rf]))

(rf/reg-sub ::teams-count
  :<- [:get [:stepchall :teams]]

  (fn [teams _]
    (count teams)))

(rf/reg-sub ::total-distance-in-km
  :<- [:get [:stepchall :total :steps]]

  (fn [total-steps _]
    (let [average-step-length 0.8]
      (-> total-steps
          (* average-step-length)
          (/ 1000)
          int))))

(defn- introductions []
  (let [main-unit-plural @(rf/subscribe [:get [:stepchall :main-unit :plural]])]
    {:call-to-action {:de "Tritt jetzt einem Team bei!"
                      :en "Participate and join a team!"}
     :body (str-tr {:de (str "Wir laden alle Mitarbeitenden ein, an unserer Challenge teilzunehmen und in "
                             "verschiedenen Teams gegeneinander anzutreten. Ziel des Wettbewerbs ist es, "
                             "mit eurem Team die meisten ")
                    :en (str "We invite all employees to join our challenge to compete against each other in "
                             "different teams. The goal is to reach the finish line and to compete with the "
                             "number of ")}
                   main-unit-plural
                   {:de " über den gesamten Wettbewerbszeitraum zu sammeln."
                    :en " of other teams."})}))

(defn ^:private introduction []
  (let [team-building-start (format-date @(rf/subscribe [:get [:stepchall :team-building-start-date]]))
        team-building-end (format-date @(rf/subscribe [:get [:stepchall :team-building-end-date]]))
        challenge-start (format-date @(rf/subscribe [:get [:stepchall :challenge-start-date]]))
        challenge-end (format-date @(rf/subscribe [:get [:stepchall :challenge-end-date]]))
        {:keys [body call-to-action]} (introductions)]
    [:div.sc_introduction
     [:h3 (t {:de "machtfit-Challenge"})]
     [:h1 (t @(rf/subscribe [:get [:stepchall :names :challenge-name]]))]
     [:p (t body)
      [:br]
      [:strong (t call-to-action)]]
     [:p (t {:de "Anmelde– und Teambildungsphase: "
             :en "Registration and team building period: "})
      [:strong {:style {:white-space "nowrap"}} (str team-building-start " - " team-building-end)]]
     [:p (t {:de "Aktive Wettbewerbsphase: "
             :en "Activity-Challenge period: "})
      [:strong {:style {:white-space "nowrap"}} (str challenge-start " - " challenge-end)]]
     [:p [:a {:href @(rf/subscribe [:get [:stepchall :product-url]])}
          (t {:de "Für weitere Informationen zur Challenge klicke hier."
              :en "Click here for further information about the Challenge."})]]]))

(defn ^:private stats []
  (let [main-unit-plural @(rf/subscribe [:get [:stepchall :main-unit :plural]])
        stats' [{:title {:de "Teilnehmende"
                         :en "Participants"}
                 :value @(rf/subscribe [:get [:stepchall :total :participants]])
                 :format :decimal}
                {:title {:de "Teams"}
                 :value @(rf/subscribe [::teams-count])
                 :format :decimal}
                {:title (str-tr main-unit-plural)
                 :value @(rf/subscribe [:get [:stepchall :total :steps]])
                 :format :decimal}

                {:title {:de "Deine Position"
                         :en "Your position"}
                 :value @(rf/subscribe [:get [:stepchall :participant :rank]])
                 :format :ordinal}

                {:title {:de "Position deines Teams"
                         :en "Your team position"}
                 :value @(rf/subscribe [:get [:stepchall :team :rank]])
                 :format :ordinal}

                (when @(rf/subscribe [::subs/steps-as-main-unit?])
                  {:title {:de "Strecke gelaufen"
                           :en "Distance walked"}
                   :value @(rf/subscribe [::total-distance-in-km])
                   :format :km})]]

    [:div.sc_stats
     (doall
      (for [{:keys [value format title]} (remove nil? stats')
            :let [value (if (some? value)
                          (case format
                            :decimal (format/decimal value)
                            :ordinal (language/ordinal value)
                            :km (str (format/decimal value) " km"))
                          "\u2013")]]
        ^{:key title} [:div.sc_stats-item
                       [:span value]
                       (t title)]))]))

(defn ^:private app-advert []
  [:div.sc_app-advert
   [:div.sc_app-advert-qr
    [:img {:src (machtfit/static "img/stepchall/ios_app_qr.svg")}]]
   [:p
    [:strong (t {:de "Die machtfit-Challenge funktioniert am besten mit unserer App."
                 :en "The machtfit-Challenge works best with our app."})]
    [:br]
    (when @(rf/subscribe [:get [:stepchall :allow-automatic-step-tracking?]])
      (t {:de "Verbinde einfach dein Polar, Garmin Fitnessarmband oder Apple Health mit unserer App."
          :en "Connect your Polar, Garmin device or Apple Health with our app."}))]
   [:div.sc_app-advert-qr
    [:img {:src (machtfit/static "img/stepchall/android_app_qr.svg")}]]
   [:div.sc_app-advert-logos
    [:a {:href "https://apps.apple.com/de/app/machtfit/id1116916354"
         :target "_blank"}
     [:img {:src (machtfit/static "img/stepchall/app-store-de.svg")}]]
    [:a {:href "https://play.google.com/store/apps/details?id=de.machtfit.poc"
         :target "_blank"}
     [:img {:src (machtfit/static "img/stepchall/google-play-de.svg")}]]]])

(defn details []
  [:div.sc_details
   [introduction]
   [stats]
   [app-advert]])
